import React from 'react'
import bg1 from '../../assets/images/bg1.svg'

const SoftwareBanner = () => {
    return (
        <div className='services-banner'>
            {/* <img src={bg1} alt='' className='' /> */}
            <div className='content'>
                <div className='title'><h1>Creating an impact requires a team with sharp minds and strategic thinking.</h1></div>
                <div className='subtitle'><span>Liberyus is a boutique software agency specializing in mobile applications, web portals, custom software, intuitive UI/UX design, modern web design, and impactful branding. We blend innovation and creativity to deliver tailored digital solutions for our clients.</span></div>
            </div>
        </div>
    )
}

export default SoftwareBanner
